import script from "./SummaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryView.vue?vue&type=script&setup=true&lang=js"

import "./SummaryView.vue?vue&type=style&index=0&id=d8d020c2&lang=scss"

const __exports__ = script;

export default __exports__